import '../../fonts.css'
import React from 'react';

const Confirm3DButton = React.memo (({ onClick, disabled }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        position: "absolute",
        bottom: "100px",
        right: "10px",
        zIndex: 1,
        border:"none",
        outline:"none",
        padding: "8px 16px",
        backgroundColor: disabled ? "#cccccc" : "#3EBAEC",
        color: disabled ? "#666666" : "White",
        borderRadius: "8px",
        width:"216px",
        height:"40px",
        cursor: disabled ? "not-allowed" : "pointer",
        fontFamily:"GoldbeckNextRegular",
        animation:"Disso",
        opacity: disabled ? 0.6 : 1
      }}
      onMouseOver={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = '#42B0E8';
          e.currentTarget.style.color = 'white';
        }
      }}
      onMouseOut={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = '#3EBAEC';
          e.currentTarget.style.color = 'white';
        }
      }}
    >
      Weiter
    </button>
  );
});
export default Confirm3DButton;